export default ({ progress }) => (
  <progress className="progress is-primary is-radiusless" value={progress} max="100" />
);
